const ogParser = function(og) {
  let ogElement = document.querySelector(`[property="${og}"]`);
  if (ogElement) {
    return ogElement.getAttribute('content');
  }
  return null;
};

export default ogParser;
